import type { FeedItemType } from '@/types';

import { downloadUtil, sendDownloadDataToReactNative } from './downloadUtil';
import { DownloadToast } from './toasts';

export const downloadDocument = async ({
  result,
  fileName,
  native,
}: DownloadDocType) => {
  try {
    DownloadToast();
    if (result !== null) {
      const link = result.object_location || result.link_to_report;

      const data = {
        url: link ?? '',
        fileName,
      };
      if (native) {
        sendDownloadDataToReactNative(data);
      } else {
        // TOD: Handle rejection from user agent
        downloadUtil(data);
      }
    }
  } catch (e) {
    console.error(e);
  }
};

type DownloadDocType = {
  result: FeedItemType;
  fileName: string;
  native: boolean;
};
